import { useContext } from "react"
import { CheckBox } from "components/Form"
import { SelectAssessmentsContext } from "../CreateAssessments"

const usePreventDuplicateBatteries = () => {
    const { setPreventDuplicateBatteries, preventDuplicateBatteries } = useContext(SelectAssessmentsContext)

    return {
        component: CheckBox,
        input: {
            value: preventDuplicateBatteries,
            onChange: setPreventDuplicateBatteries
        },
        label: "לא מאפשר יצירה של סוללה כפולה"
    }

}

export default usePreventDuplicateBatteries